let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a2C9b")).then(() => parcelRequire('if7fN'));